// import { media } from '../mixins/media';
// import type { Breakpoints } from '../theme/breakpoints';
// import { breakpoints } from '../theme/breakpoints';
import type { BreakpointValues } from '../types/breakpoints';
import type { Breakpoints } from '../theme/breakpoints';
import { breakpoints } from '../theme/breakpoints';
import { media } from './media';

export type MapFunction<T> = (value: T) => string;

/**
 * Maps breakpoints and their respective values to CSS media queries
 * @param {string|object} values Input value, optionally for a given breakpoint (e.g. 'primary10' or {m: 'primary10'})
 * @param {Function} map Function that takes input value as argument and returns CSS expression
 * @returns {string} CSS media queries for each requested breakpoint
 */
const mapToBreakpoints = <T>(
  values: BreakpointValues<T>,
  map: MapFunction<T>,
): string[] | string => {
  const returnValues = [];
  if (values === null || typeof values !== 'object') {
    return map(values as T);
  }

  for (const key of Object.keys(values)) {
    if (!breakpoints[key as Breakpoints]) continue;

    const mappedValues = map((values as Record<string, any>)[key]);

    returnValues.push(media.greaterThan(key as any)`
      ${mappedValues}
    `);
  }

  return returnValues;
};

export { mapToBreakpoints };
